/**
 * API接口服务
 * 封装所有后端API接口调用
 */
import {getRequest, postRequest} from './http'
import axios from 'axios'

// 获取服务器基础URL（用于拼接图片地址）
export const getBaseUrl = () => {
  return axios.defaults.baseURL || ''
}

// 解析图片JSON字符串，返回完整URL数组
export const parseImages = (imagesJson) => {
  if (!imagesJson) return []
  try {
    const images = typeof imagesJson === 'string' ? JSON.parse(imagesJson) : imagesJson
    if (Array.isArray(images)) {
      return images.map(img => {
        // 如果已经是完整URL，直接返回
        if (img.startsWith('http://') || img.startsWith('https://')) {
          return img
        }
        // 相对路径，拼接服务器地址
        return getBaseUrl() + img
      })
    }
    return []
  } catch (e) {
    console.error('解析图片JSON失败:', e)
    return []
  }
}

// 获取第一张图片URL
export const getFirstImage = (imagesJson) => {
  const images = parseImages(imagesJson)
  return images.length > 0 ? images[0] : ''
}

// 拼接图片URL（单张图片）
export const getImageUrl = (imagePath) => {
  if (!imagePath || imagePath === '') return ''
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath
  }
  return getBaseUrl() + imagePath
}

/* ==================== 首页接口 ==================== */

/**
 * 获取发展历程列表
 * @returns {Promise}
 */
export const getHomeDevelopment = () => {
  return getRequest('/api/home/development', {})
}

/**
 * 获取推荐企业动态（1条）
 * @returns {Promise}
 */
export const getHomeNews = () => {
  return getRequest('/api/home/news', {})
}

/**
 * 获取推荐学术咨询（3条）
 * @returns {Promise}
 */
export const getHomeAcademic = () => {
  return getRequest('/api/home/academic', {})
}

/* ==================== 关于我们接口 ==================== */

/**
 * 获取企业介绍
 * @returns {Promise}
 */
export const getAboutIntro = () => {
  return getRequest('/api/about/intro', {})
}

/**
 * 获取获奖与称号列表
 * @returns {Promise}
 */
export const getAboutAwards = () => {
  return getRequest('/api/about/awards', {})
}

/* ==================== 产品中心接口 ==================== */

/**
 * 获取产品分类列表
 * @returns {Promise}
 */
export const getProductCategories = () => {
  return getRequest('/api/product/categories', {})
}

/**
 * 获取产品列表（分页）
 * @param {Object} params - 请求参数
 * @param {number} [params.categoryId] - 分类ID，不传则查询全部
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @returns {Promise}
 */
export const getProductList = (params = {}) => {
  return getRequest('/api/product/list', params)
}

/**
 * 获取产品详情
 * @param {number} id - 产品ID
 * @returns {Promise}
 */
export const getProductDetail = (id) => {
  return getRequest(`/api/product/${id}`, {})
}

/* ==================== 资讯接口（学术咨询/企业动态） ==================== */

/**
 * 获取资讯分类列表
 * @param {number} type - 类型：1=学术咨询，2=企业动态
 * @returns {Promise}
 */
export const getArticleCategories = (type) => {
  return getRequest('/api/article/categories', {type})
}

/**
 * 获取推荐资讯（2条）
 * @param {number} type - 类型：1=学术咨询，2=企业动态
 * @param {number} [categoryId] - 分类ID，不传则查询全部
 * @returns {Promise}
 */
export const getArticleRecommend = (type, categoryId) => {
  const params = {type}
  if (categoryId !== undefined && categoryId !== null) {
    params.categoryId = categoryId
  }
  return getRequest('/api/article/recommend', params)
}

/**
 * 获取资讯列表（分页）
 * @param {Object} params - 请求参数
 * @param {number} params.type - 类型：1=学术咨询，2=企业动态
 * @param {number} [params.categoryId] - 分类ID，不传则查询全部
 * @param {number} [params.pageNum=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @returns {Promise}
 */
export const getArticleList = (params) => {
  return getRequest('/api/article/list', params)
}

/**
 * 获取资讯详情
 * @param {number} id - 文章ID
 * @returns {Promise}
 */
export const getArticleDetail = (id) => {
  return getRequest(`/api/article/${id}`, {})
}

/* ==================== 联系我们接口 ==================== */

/**
 * 提交联系表单
 * @param {Object} data - 表单数据
 * @param {string} data.name - 姓名（必填）
 * @param {string} data.phone - 联系电话（必填）
 * @param {string} [data.company] - 公司名称
 * @param {string} [data.message] - 留言内容
 * @returns {Promise}
 */
export const submitContactForm = (data) => {
  return postRequest('/api/contact/submit', data)
}

/* ==================== 导出所有API ==================== */
export default {
  // 工具函数
  getBaseUrl,
  parseImages,
  getFirstImage,
  getImageUrl,
  // 首页
  getHomeDevelopment,
  getHomeNews,
  getHomeAcademic,
  // 关于我们
  getAboutIntro,
  getAboutAwards,
  // 产品中心
  getProductCategories,
  getProductList,
  getProductDetail,
  // 资讯
  getArticleCategories,
  getArticleRecommend,
  getArticleList,
  getArticleDetail,
  // 联系我们
  submitContactForm
}
